import React, { useState, forwardRef } from 'react';
import { SENATE } from '@/constants';
import Icon from '../Icon';

const SwiperPreviousButton = forwardRef(({ className = '' }, ref) => {
  const [arrowPrevColor, setArrowPrevColor] = useState(SENATE);
  // const [arrowNextColor, setArrowNextColor] = useState(SENATE);

  return (
    <div
      role="presentation"
      ref={ref}
      className="swiper-button-prev flex justify-center items-center w-[36px] h-[36px] bg-light-white rounded-full"
      onMouseEnter={() => setArrowPrevColor(SENATE)}
      onMouseLeave={() => setArrowPrevColor(SENATE)}
    >
      <Icon
        type="angle-right"
        color={arrowPrevColor}
        className="size-[36px] -translate-x-0.5 rotate-180"
      />
    </div>
  );
});

SwiperPreviousButton.displayName = 'SwiperPreviousButton';

export default SwiperPreviousButton;
